import { isSelfHosted } from "@/helpers/self-hosted.helper"
import { Fragment } from "react"
import { ReportProvider as Provider } from "./ReportProvider"

const selfHosted = isSelfHosted()

export const ReportProvider = selfHosted ? Fragment : Provider
